export const mockCaptchaSiteKey = {
  captchaSiteKey: '6LdkJ68UAAAAAHX6AnX2pKOP-gWLprObxEHHMVth'
};

export default mockCaptchaSiteKey;
